import { render, staticRenderFns } from "./WorldClassForm.vue?vue&type=template&id=0b2542a4&"
import script from "./WorldClassForm.vue?vue&type=script&lang=js&"
export * from "./WorldClassForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports